import script from "./ListText.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListText.vue?vue&type=script&setup=true&lang=ts"

import "./ListText.vue?vue&type=style&index=0&id=5a9e43ef&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9e43ef"]])

export default __exports__